module.exports = __webpack_public_path__ + "static/img/manual-12.543885f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-12.png
// module id = QCqC
// module chunks = 4